import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import CouponActions from '../../Redux/CouponRedux'
// import RenderTable from './RenderTable'

class IndividualModem extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedModem: null,
      form: {
        discountable_type: 'product',
        discountable_id: ''
      }
    }
  }

  _selectChange = (selectedModem) => {
    let form = { ...this.state.form }
    form.discountable_id = selectedModem.value
    this.setState({
      selectedModem,
      form
    })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    if (this.props.source_type === 'coupon-user') {
      let uuid = this.props.uuid
      let data = { uuid, form }
      this.props.postCouponItem(data)
    } else {
      let tag = this.props.tag
      let data = { tag, form }
      this.props.postCouponItemTag(data)
    }
    setTimeout(() => {
      this.props.fetchCouponItem()
    }, 500)
  }

  render () {
    const { product } = this.props
    let modemPicker = []
    product.custom.map((item, i) => (
      modemPicker[i] = {
        value: item.id,
        label: item.title
      })
    )

    return (
      <section>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-10'>
              <Select
                options={modemPicker}
                value={this.state.selectedModem}
                onChange={(selectedModem) => this._selectChange(selectedModem)}
                placeholder='Select Wifi Product to add ...'
              />
            </div>
            <div className='col-2'>
              <button type='submit' className='btn btn-primary'>Add</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({
  coupon: state.coupon,
  product: state.product
})

const dispatchToProps = (dispatch) => ({
  postCouponItem: (data) => dispatch(CouponActions.postCouponItemRequest(data)),
  postCouponItemTag: (data) => dispatch(CouponActions.postCouponItemTagRequest(data))
})

export default connect(stateToProps, dispatchToProps)(IndividualModem)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/IndividualModem.js